import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { RenderSelect } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

var _ = require('lodash');

class ChangeDomainProfileModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      user_domain_profiles: []
    }
  }

  submit = (values) => {
    const { onHide, reset, invoice_item_obj } = this.props;
    if(values.domain_profile_id) {
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/invoice/item/domain_profile/modify',
        data: {
          invoice_item_id: invoice_item_obj.id,
          domain_profile_id: values.domain_profile_id
        },
        withCredentials: true
      }).then(function (response) {
         if(!response.data.isError) {
          reset();
          onHide();
          toast.success("Thay đổi bản khai dịch vụ thành công !");
         }
      })
    }
  }

  // Lấy danh sách bản khai theo id khách hàng.
  getDomainProfileList = () => {
    const { invoiceObject } = this.props;
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/customer/domain_profile',
      data: {
        customer_id: invoiceObject.user.id
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          user_domain_profiles: response.data.data
        })
      }
    })
  }

  setDomainSelectedId(domain_profile_id_selected) {
    this.setState({
      domainSelectedId: domain_profile_id_selected
    })
  }
  

  handleHideModal = () => {
    const { onHide, reset } = this.props;
    reset();
    onHide();
  }
  
  componentDidMount() {
    this.getDomainProfileList();
  }

  render() {

    const { title, submitting, handleSubmit, templates, invoice_item_obj, rolePath } = this.props;
    const { user_domain_profiles, domainSelectedId } = this.state;
    const modalConfig = { enforceFocus: false, backdrop: 'static', show: this.props.show, size: "lg", onHide: this.props.onHide, submitting: this.props.submitting };
    var domain_profile_options = [];

    _.forEach(user_domain_profiles,(i,key) => { // Push option Item by form type
      if(!i.is_company && !i.parent_id) { // Is Personal
        domain_profile_options.push(
          {
            label: `( Cá Nhân ) ${i.full_name} - ${i.email} - CMND: ${i.id_number} - SĐT: ${i.phone}`, 
            value:i.id,
            isDisabled: i.id == invoice_item_obj.domain_profile_id
          }
        );
      } else if (!i.parent_id && i.is_company) { // Is Company
        domain_profile_options.push(
          { 
            label: `( Công Ty ) ${i.full_name} - ${i.email} - MST: ${(i.vat_no != null ?  i.vat_no : "")} - SĐT: ${i.phone}`,
            value: i.id,
            isDisabled: i.id == invoice_item_obj.domain_profile_id
          }
        );
      }
    })

    return ( 
      <Modal
        bsPrefix = "modal"
        {...modalConfig}
        dialogClassName="modal-open">
          <ToastContainer />
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
          </Modal.Header>
          <form style={{marginBottom: 0}} onSubmit={handleSubmit(this.submit)}>
            <Modal.Body>
              <Field name="domain_profile_id" label="Danh Sách Bản Khai" options={domain_profile_options} onChangeAction={(value)=> this.setDomainSelectedId(value)} component={RenderSelect}></Field>
              {domainSelectedId && <a target="_blank" style={{float: "right"}} href={rolePath + "/customer/profile/detail/" + domainSelectedId}> Chi Tiết</a>}
              <br/>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a className="btn" onClick={this.handleHideModal}>Đóng</a>
                <button type="submit" className="btn bg-primary" disabled={submitting}>Cập nhật</button>
              </div>
            </Modal.Footer>
          </form>
      </Modal>
    )
  }
}
const mapState = (state,props) => ({

});

const mapDispatch = dispatch => ({
  
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'ChangeDomainProfileModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
  })(withRouter(ChangeDomainProfileModal))));
